import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ListItemActionsDirective } from './list-item-actions.directive';

@NgModule({
  declarations: [
    ListItemActionsDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ListItemActionsDirective
  ]
})
export class ListItemActionsModule { }
